"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../../helpers");
var getPlacementFromAdUnitId_1 = __importDefault(require("../utils/getPlacementFromAdUnitId"));
var isADOSLoaded = function () {
    return window === null || window === void 0 ? void 0 : window.ados_add_placement;
};
function default_1(_a) {
    var adUnitId = _a.adUnitId, innerPlacement = _a.innerPlacement, properties = _a.properties, _b = _a.overrides, overrides = _b === void 0 ? {} : _b, _c = _a.headerBiddingKeywords, headerBiddingKeywords = _c === void 0 ? "" : _c, _d = _a.kevelOnly, kevelOnly = _d === void 0 ? false : _d;
    var setupKevel = function () {
        window
            .ados_add_placement(innerPlacement.networkId, innerPlacement.siteId, adUnitId, innerPlacement.adTypes)
            .setZone(innerPlacement.zone)
            .setProperties(properties)
            .setOverrides(overrides);
        window.ados_setConsent({ gdpr: true });
        window.ados_setKeywords(headerBiddingKeywords);
        window.ados_load();
        (0, helpers_1.getCookie)("debug-ads") && console.debug("".concat(adUnitId, ": ados_load() ran."));
    };
    var placement = (0, getPlacementFromAdUnitId_1.default)(adUnitId);
    if (isADOSLoaded()) {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.debug("".concat(adUnitId, ": ados detected in window, loading auction."));
        if (kevelOnly) {
            console.debug("".concat(adUnitId, ": is a only kevel ad, loading ados run"));
            if (typeof window.__atha !== "undefined") {
                var id = window.__atha.sendRequest(placement, "kevel", __assign({ zoneId: innerPlacement.zone }, innerPlacement));
                window.ads = window.ads || {};
                window.ads[placement] = __assign(__assign({}, window.ads[placement]), { requestId: id });
            }
            // taken from ados documentation it states to declare ados before using run
            var ados = window.ados || {};
            ados.run = ados.run || [];
            ados.run.push(function () {
                setupKevel();
            });
        }
        else {
            setupKevel();
        }
    }
    else {
        console.error("Couldn't find ados in the window context. Can't fetch ad with kevel");
    }
}
exports.default = default_1;
